module.exports = __webpack_public_path__ + "media/images/inventory-7bad521d.png";